export const pageToModuleMap = {
    "dashboard": null, // Dashboard is always visible
    "employees": "employees",
    "attendance": "attendance",
    "reports": "reports",
    "calendar": "calendar",
    "messages": "messages",
    "DocumentsManagement": "documents",
    "LeaveApprovalPage": "leaves",
    "AdvancementsManagement": "advancements",
    "ChangesPage": "changesPage", // Employee changes uses separate changesPage module
    "Payroll": "payroll",
    "TaxCalculator": "payroll", // Tax calculator is part of payroll
    "companyConfig": "configurations", // Company Configuration - accessible by admin levels
    "Settings": null,
};

// Pages that should only appear in Admin View (not in Manager View).
// Mirrors the backend MANAGER_ACTIONS whitelist, which grants none of these.
export const adminOnlyPages = ["Payroll", "companyConfig", "DocumentsManagement"];